import React, { useState, Fragment, Component } from 'react'
import BankSoalBloc from "../Blocs/BankSoalBloc"
import { config } from "../../../../../helpers/config_global"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { cancelToken } from "../../../../../services/adapters/master/penialian360Service"
import apiResponse from '../../../../../services/apiResponse'
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import CustomSelect from "../../../../../helpers/ui/CustomSelect"
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import "./style.css";
import "../../JenisJabatan/Components/jabatan.css";
import * as XLSX from 'xlsx'; 



import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    Tooltip,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Spinner
} from "reactstrap"



class IndexComponent extends Component 
{
    bankSoalBloc = new BankSoalBloc();

    source
    historyTable = 'banksoal360Active'
    defaultOrder = 'ms360_question_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
 

    constructor(props) {
        super(props)
        this.state = {
            messageFailed: "Data gagal disimpan",
            filter_type_uuid: 'all',
            filter_level: 'all',
            filterTypeOptions: [],
            filterLevelOptions: [],
            inactiveUuid: '',
            loadingContent: true,
            loadingCompentence: false,
            bulkInsert: [],
            bulkInsertLoading: false,
            bulkInsertError: "",
            statuses: [],
            levels: [],
            competences: [],
            types: [],
            dataForm: {},
            obj: null,
            modalImport: false,
            modalShow: false,
            modalToggle: false,
            tooltip: false,  
            detailUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
        this.fileInputRef = React.createRef();
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

     loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            filter_type_uuid: this.state.filter_type_uuid,
            filter_level: this.state.filter_level

        }
        await this.bankSoalBloc.fetchDataTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault();
        var userdata = JSON.parse(localStorage.getItem("userdata"));
        var create_uuid = userdata.employee_uuid;
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true,
        });
    };

     confirmResponse = async (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                
                this.submitData()

                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    submitData = async () => {

        if(this.state.inactiveUuid !== '' && this.state.inactiveUuid !== null){
            await this.bankSoalBloc.fetchDelete({ uuid: this.state.inactiveUuid })
        }else{
            const dataForm = this.state.dataForm;
            const formData = new FormData();

            if(this.state.obj !== undefined && this.state.obj !== null){
                formData.append("uuid", this.state.obj.ms360_question_uuid ?? "");
            }

            formData.append("ms360_question_type_uuid", dataForm.ms360_question_type_uuid);
            formData.append("ms360_question_position_level", dataForm.ms360_question_position_level);
            formData.append("ms360_question_competence_uuid", dataForm.ms360_question_competence_uuid);
            formData.append("ms360_question_indicator", dataForm.ms360_question_indicator);
            formData.append("ms360_question_question", dataForm.ms360_question_question);
            formData.append("ms360_question_sort", dataForm.ms360_question_sort);
            formData.append("ms360_question_status", dataForm.ms360_question_status);
            await this.bankSoalBloc.fetchSubmit(formData)
        }

    };

    componentDidMount() {

        this.bankSoalBloc.fetchOption({})

        this.bankSoalBloc.bankSoalOptionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        statuses: response.status,
                        levels: response.levels,
                        types: response.types,
                        loadingContent: false,
                        filterTypeOptions: [
                            {
                                value: 'all',
                                label: 'Semua Bagian'
                            },
                            ...response.types
                        ],
                        filterLevelOptions: [
                            {
                                value: 'all',
                                label: 'Semua Level'
                            },
                            ...response.levels
                        ]
                    })
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.bankSoalBloc.bankSoalSubmitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        modalShow: false,
                        modalToggle: false,
                    });
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

         this.bankSoalBloc.bankSoalDeleteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const status = result.data.status
                    this.setState({
                        failed: status === false,
                        loading: false,
                        success: true,
                        modalShow: false,
                        modalToggle: false,
                        inactiveUuid: '',
                        obj: null,
                        messageFailed: status ? '' : response?.message
                    });
                    if(status){
                        this.setTokenAPI()
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.bankSoalBloc.bankSoalDatatableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.bankSoalBloc.bankSoalImportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        bulkInsertLoading: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        bulkInsertLoading: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        bulkInsertError: '',
                        bulkInsertLoading: false,
                        modalImport: false,
                        bulkInsert: []
                    });
                    this.setTokenAPI();
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

         this.bankSoalBloc.bankSoalCompetenceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingCompentence: true
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingCompentence: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        loadingCompentence: false,
                        competences: response.options
                    });
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    
    }

    handleExcelFileChange = async(e) => {
		const file = e.target.files[0];
		if (!file) return;

		// Validasi extension
		const allowedExtensions = ['xlsx', 'xls'];
		const extension = file.name.split('.').pop().toLowerCase();

		if (!allowedExtensions.includes(extension)) {
			this.setState({
				excelError: 'Format file harus Excel (.xlsx atau .xls)',
				excelFile: null,
				excelFileName: ''
			});
			return;
		}

		const buffer = await file.arrayBuffer();
		const workbook = XLSX.read(buffer, { type: "array" });

		const firstSheetName = workbook.SheetNames[0];
		const worksheet = workbook.Sheets[firstSheetName];

		// header: 1 → array-of-arrays, so row 0 is the header row itself
		const rows = XLSX.utils.sheet_to_json(worksheet, {
			header: 1,
			defval: "",
			blankrows: false,
		});

		const dataRows = rows.slice(1); // skip header row

		const result = dataRows.map((row) => ({
			bagian: String(row[0] ?? "").trim(),
			levelTarget: String(row[1]).toLowerCase() === 'universal' ? 0 : Number(row[1]) ?? 0,
			kompetensi: String(row[2] ?? "").trim(),
			indikatorPerilaku: String(row[3] ?? "").trim(),
			pertanyaanSurvey: String(row[4] ?? "").trim(),
			urutan: Number(row[5] ?? 0),
		}));

        this.setState({ bulkInsert: result })

	};

    handlFilterCompetence = async (uuid) => {
        await this.bankSoalBloc.fetchCompetence({ uuid: uuid })
    }

    columns = [
        {
            key: "ms360_question_type_name",
            text: "BAGIAN",
            className: "ms360_question_type_name",
            sortable: true,
        },
        {
            key: "ms360_question_position_level",
            text: "LEVEL TARGET",
            className: "ms360_question_position_level",
            sortable: true,
            align: 'center',
            cell: record => {
                const level = parseInt(record.ms360_question_position_level);
                if(level === 0){
                    return (<span className="badge bg-warning p-2">Universal</span>)
                }else{
                    return (<span className={`level-${level} p-2 border`}>Level {level}</span>)
                }
            }
        },
        {
            key: "ms360_question_question",
            text: "KOMPETENSI DAN PERTANYAAN",
            className: "ms360_question_question",
            sortable: true,
             cell: record => {
               return (
                    <Fragment>
                        <span className='d-block'>
                            <strong>
                                <small>{record?.ms360_competence_name}</small>
                            </strong>
                        </span>
                        <p className='d-block'>
                           {record?.ms360_question_question}
                            <span className='d-block text-muted mt-1'>
                                <small>{record?.ms360_question_indicator}</small>
                            </span>
                        </p>
                       
                    </Fragment>
               )
            }
        },
        {
            key: "ms360_question_status",
            text: "Status",
            className: "ms360_question_status",
            sortable: true,
            align: 'center',
            cell: record => {
                const status = parseInt(record.ms360_question_status);
                if(status === 1){
                    return (<span className="badge bg-success">Aktif</span>)
                }else{
                    return (<span className="badge bg-danger">Non-Aktif</span>)
                }
            }
        },
        {
            key: "action",
            text: "AKSI",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.ms360_question_uuid;

                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-warning btn-sm"
                                id={"update-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        competences: [],
                                        obj: record,
                                        updateUuid: thisId,
                                        modalShow: true
                                    })
                                    this.handlFilterCompetence(record?.ms360_question_type_uuid)
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-pen"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["update" + thisId] : !this.state["update" + thisId]
                                    })
                                }}
                            >Perbaharui</Tooltip>
                        </span>
                        <span>
                            <button 
                                className="btn btn-danger btn-sm" 
                                id={"delete-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        inactiveUuid: record.ms360_question_uuid,
                                        confirm: true,
                                        competences: []
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-trash-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["delete" + thisId] : !this.state["delete" + thisId]
                                    })
                                }}
                            >Hapus</Tooltip>
                        </span>
                    </Fragment>
                )
            }
        }
    ]

    handleTemplate(){
        
        const headers = [
			"Bagian",
			"Level Target",
			"Kompetensi",
			"Indikator Perilaku",
			"Pertanyaan Survey",
			"Urutan",
		];

        const rows = [
            {
                bagian: "BerAKHLAK",
                levelTarget: "Universal",
                kompetensi: "Berorientasi Pelayanan",
                indikatorPerilaku: "Memahami dan memenuhi kebutuhan masyarakat",
                pertanyaanSurvey: "Bagaimana pegawai ini dalam memberikan pelayanan yang ramah dan solutif?",
                urutan: 1,
            },
            {
                bagian: "MANSOSKUL",
                levelTarget: 3,
                kompetensi: "Kepemimpinan & Pengambilan Keputusan",
                indikatorPerilaku:"Mampu mengambil keputusan yang tepat pada situasi kompleks",
                pertanyaanSurvey:"Seberapa baik pegawai ini dalam mengarahkan tim dan mengambil keputusan operasional?",
                urutan: 2,
            },
        ];

        const data = rows.map((r) => [
			r.bagian,
			r.levelTarget,
			r.kompetensi,
			r.indikatorPerilaku,
			r.pertanyaanSurvey,
			r.urutan,
		]);

        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);

		worksheet["!cols"] = [
			{ wch: 14 }, // Bagian
			{ wch: 14 }, // Level Target
			{ wch: 30 }, // Kompetensi
			{ wch: 40 }, // Indikator Perilaku
			{ wch: 50 }, // Pertanyaan Survey
			{ wch: 8 },  // Urutan
		];

		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Template Bank Soal");

		const now = new Date();
		const pad = (n) => String(n).padStart(2, "0");
		const timestamp =
		`${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_` +
		`${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

		XLSX.writeFile(workbook,`bank_soal_${timestamp}.xlsx`);

    }

    doImport = async () => {
        const formSubmit = { items: this.state.bulkInsert };
        await this.bankSoalBloc.fetchImport(formSubmit);
    };

    handleFilter = () => {
        this.setTokenAPI()
    }

    handleBagian =  (opt) => {
        this.setState({ filter_type_uuid: opt.value })
        setTimeout(() =>  {
            this.setTokenAPI()
        }, 500)
    }

    handleLevel = async (opt) => {
        this.setState({ filter_level: opt.value })
        setTimeout(() =>  {
            this.setTokenAPI()
        }, 500)
    }


    componentWillUnmount(){
        this.bankSoalBloc.bankSoalDatatableChannel.unsubscribe()
        this.bankSoalBloc.bankSoalSubmitChannel.unsubscribe()
        this.bankSoalBloc.bankSoalOptionChannel.unsubscribe()
        this.bankSoalBloc.bankSoalDeleteChannel.unsubscribe()
        this.bankSoalBloc.bankSoalImportChannel.unsubscribe()
        this.bankSoalBloc.bankSoalCompetenceChannel.unsubscribe()
    }

    render(){
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            { this.state.loadingContent ? <>
                                <Card className="">
                                    <CardBody>
                                        <div id="loader"
                                            className="top-0 start-0 w-100 h-100
                                                    d-flex justify-content-center align-items-center
                                                    bg-white bg-opacity-75">
                                            <div className="text-center text-primary">
                                                <i className="bi bi-arrow-repeat fs-1"></i>
                                               <div className="d-flex align-items-center text-primary">
                                                    <span className="spinner-border me-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </span>
                                                    <small>Memuat Data...</small>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </> : <>
                                <Card className="">
                                    <CardBody>
                                        <div className="info-badge mb-4">
                                            <div className="info-icon">i</div>
                                            <div className="info-content">
                                                <div><span className="info-title-badge">Bank Soal Dinamis (Level Hierarki 1–5)</span></div>
                                                <div>
                                                Soal dengan Level Target <strong>&quot;Universal&quot;</strong> (22 Soal BerAKHLAK) akan ditampilkan kepada seluruh pegawai. Sisa soal diambil berdasarkan <strong>Level Hierarki Evaluatee (1–5)</strong> untuk bagian MANSOSKUL (Manajerial, Sosio-Kultural &amp; Teknis).
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mb-4 mt-2'>
                                            <div className='row'>
                                                <div className='col-md-3'>
                                                    <Label className="col-md-3 col-form-label">
                                                        Filter Bagian <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="9 w-100">
                                                        <CustomSelect 
                                                            isAvForm={false}
                                                            name={`filter_bagian`}
                                                            errorMessage="Pilih  Filter Bagian"
                                                            options={this.state.filterTypeOptions} 
                                                            validate={{ required: { value: false } }}
                                                            placeholder="Pilih Filter Bagian"
                                                            isLoading={false}
                                                            defaultValue={this.state.filter_type_uuid}
                                                            onChange={(opt)=> this.handleBagian(opt)}
                                                        />
                                                    </Col>
                                                </div>
                                                 <div className='col-md-3'>
                                                    <Label className="col-md-3 col-form-label">
                                                        Filter Level <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="9 w-100">
                                                        <CustomSelect 
                                                            isAvForm={false}
                                                            name={`filter_level`}
                                                            errorMessage="Pilih Filter Level"
                                                            options={this.state.filterLevelOptions} 
                                                            validate={{ required: { value: false } }}
                                                            placeholder="Pilih Filter Level"
                                                            isLoading={false}
                                                            defaultValue={this.state.filter_level}
                                                            onChange={(opt)=> this.handleLevel(opt)}
                                                        />
                                                    </Col>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="float-end">
                                            <Button onClick={this.handleFilter} color="warning">
                                                <i className="uil uil-filter me-2"></i>Filter
                                            </Button>
                                             <Button onClick={this.handleTemplate} color="secondary" className='ms-2 me-2'>
                                                <i className="uil-download-alt me-2"></i>Template Excel
                                            </Button>
                                             <Button onClick={() => { this.setState({ modalImport:true }) }} color="success" className='me-2'>
                                                <i className="uil-upload me-2"></i>Import Excel
                                            </Button>
                                            <Button onClick={() => { this.setState({ modalShow:true, obj:null, competences: [] }) }} color="primary">
                                                <i className="uil-plus me-2"></i>Tambah Soal
                                            </Button>
                                        </div>
                                        <CardTitle>Daftar Bank Soal</CardTitle>
                                        <CardSubtitle className="mb-3">
                                            Kelola Bank Soal
                                        </CardSubtitle>
                                        <hr />
                                        <MKIDatatable
                                            className={this.configDatatable.tableClass}
                                            config={this.configDatatable}
                                            records={this.state.rows}
                                            columns={this.columns}
                                            dynamic={true}
                                            minWidth={1000}
                                            total_record={this.state.totalRow}
                                            initial={this.state.filter}
                                            onChange={(filter) => {
                                                this.setState({
                                                    loadingTable: true,
                                                    filter: filter
                                                }, function () {
                                                    this.setTokenAPI()
                                                });
                                            }}
                                            loading={this.state.loadingTable}
                                        />
                                    </CardBody>
                                </Card>
                            </> }
                        </Col>
                    </Row>
                </Container>
                 <Modal isOpen={this.state.modalShow} size="lg" toggle={this.state.modalToggle}>
                    <AvForm className="needs-validation" onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}>
                        <ModalHeader toggle={this.state.modalToggle}>
                            { this.state.obj !== undefined && this.state.obj !== null ? <>Edit Soal Bank Soal</> : <>Tambah Soal Bank Soal</> }
                        </ModalHeader>
                        <ModalBody>
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Bagian Soal <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <CustomSelect 
                                        name={`ms360_question_type_uuid`}
                                        errorMessage="Pilih Bagian Soal"
                                        options={this.state.types} 
                                        validate={{ required: { value: true } }}
                                        placeholder="Pilih Bagian Soal"
                                        isLoading={this.state.loadingCompentence}
                                        defaultValue={this.state.obj?.ms360_question_type_uuid ?? ""}
                                        onChange={opt => this.handlFilterCompetence(opt.value)}
                                    />
                                </Col>
                            </Row>       
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Nama Kompentensi <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                     <CustomSelect 
                                        name={`ms360_question_competence_uuid`}
                                        errorMessage="Pilih Bagian Kompentensi"
                                        options={this.state.competences} 
                                        validate={{ required: { value: true } }}
                                        placeholder="Pilih Bagian Kompentensi"
                                        isLoading={false}
                                        defaultValue={this.state.obj?.ms360_question_competence_uuid ?? ""}
                                    />
                                </Col>
                            </Row>   
                             <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Level Target <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <CustomSelect 
                                        name={`ms360_question_position_level`}
                                        errorMessage="Pilih Bagian Level Target "
                                        options={this.state.levels} 
                                        validate={{ required: { value: true } }}
                                        placeholder="Pilih Bagian Level Target "
                                        isLoading={false}
                                        defaultValue={this.state.obj?.ms360_question_position_level ?? ""}
                                    />
                                </Col>
                            </Row>   
                           
                             <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Indikator Perilaku
                                </Label>
                                <Col md="9">
                                    <AvField
                                        placeholder="Indikator Perilaku"
                                        name="ms360_question_indicator"
                                        type="text"
                                        validate={{ required: { value: false } }}
                                        value={this.state.obj?.ms360_question_indicator ?? ""}
                                    />   
                                </Col>
                            </Row>   
                             <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Pertanyaan Survey <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                     <AvField
                                        rows={4}
                                        placeholder="Pertanyaan Survey"
                                        name="ms360_question_question"
                                        type="textarea"
                                        errorMessage="Masukkan Pertanyaan Survey"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        id="ms360_question_question"
                                        value={this.state.obj?.ms360_question_question ?? ""}
                                    />    
                                </Col>
                            </Row>      
                             <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Urutan Tampil <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                     <AvField
                                        placeholder="Urutan Tampil"
                                        name="ms360_question_sort"
                                        type="number"
                                        validate={{ required: { value: false } }}
                                        value={this.state.obj?.ms360_question_sort ?? 1}
                                    />   
                                </Col>
                            </Row>   
                             <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Status Soal <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <CustomSelect 
                                        name={`ms360_question_status`}
                                        errorMessage="Pilih Bagian Status Soal"
                                        options={this.state.statuses} 
                                        validate={{ required: { value: true } }}
                                        placeholder="Pilih Bagian Status Soal "
                                        isLoading={false}
                                        defaultValue={this.state.obj?.ms360_question_status ?? ""}
                                    />
                                </Col>
                            </Row>   
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => { this.setState({ modalShow: false }) }}>
                                Batal
                            </Button>{" "}
                            <Button color="primary" type="submit">
                                { this.state.obj !== undefined && this.state.obj !== null ? <>Update</> : <>Simpan</> }
                            </Button>           
                        </ModalFooter>
                    </AvForm>                 
                 </Modal>
                  <Modal isOpen={this.state.modalImport} size="md" toggle={this.state.modalToggle}>
                       <ModalHeader>
                            <h3><i className="uil-upload me-2"></i>Import Excel</h3>
                        </ModalHeader>     
                        <ModalBody>
                            <p className="bg-success mt-2 mb-2 p-2 text-white">
                                Upload file Excel (.xlsx / .xls) yang berisi daftar soal kuesioner. Gunakan tombol "Template Excel" untuk melihat contoh format kolom.
                            </p>
                            <Row className="mb-3">
                                <label className="col-md-3 col-form-label">
                                    File Excel <span className="text-danger">*</span>
                                </label>
                                <Col md="9">
                                    <div className="input-group mb-4">
                                        <input
                                            ref={this.fileInputRef}
                                            type="file"
                                            className="form-control"
                                            accept=".xlsx,.xls"
                                            onChange={this.handleExcelFileChange}
                                        />
                                    </div>
                                     { this.state.bulkInsertLoading ? <>
                                        <div className=''>
                                            <Spinner size="sm" className="me-1" />
                                             Memproses...
                                        </div>
                                    </> : <></> }
                                    { this.state.bulkInsertError ? <>
                                        <p className="bg-danger mt-2 mb-2 p-2 text-white">
                                            {this.state.bulkInsertError}
                                        </p>
                                    </> : <></> }
                                </Col>
                            </Row>
                        </ModalBody> 
                        <ModalFooter>
                            <Button color="secondary" disabled={this.state.bulkInsertLoading} onClick={() => { this.setState({ modalImport: false }) }}>
                                Batal
                            </Button>{" "}
                            <Button color="primary" disabled={this.state.bulkInsertLoading} onClick={this.doImport}>
                                <i className="uil-upload me-2"></i>Impor Soal
                            </Button>           
                        </ModalFooter>                
                  </Modal>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={this.state.inactiveUuid ? 'Apakah anda yakin hapus data' : "Apakah anda yakin data tersebut sudah benar?"}
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo={'Data berhasil diperbaharui'}
                    failedTitle="Gagal!"
                    failedInfo={this.state.messageFailed}
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }

}

export default IndexComponent